import WljConfirmModal from "../../components/WljConfirmModal";

const MessageConfirmModal = ({
  show,
  title,
  confirmLabel,
  onConfirm,
  onClose,
  variant = "primary",
  isLoading = false,
  icon = null,
}) => (
  <WljConfirmModal
    show={show}
    title={title}
    icon={icon}
    confirmLabel={confirmLabel}
    onConfirm={onConfirm}
    onClose={onClose}
    variant={variant}
    isLoading={isLoading}
    showCancel
  />
);

export default MessageConfirmModal;
